// packages/console/src/lib/roles.ts
//
// Workspace-role predicates shared across the console. Roles ride on the
// session's active workspace (api/tenancy WorkspaceView.role).

// isAdminRole is the single source of truth for admin-surface visibility (today
// the probe bit-distribution graph): a workspace "admin" or "owner", where
// owner is a superset of admin.
export function isAdminRole(role: string | undefined): boolean {
  return role === "admin" || role === "owner";
}
